import { TQueryDefWrapper } from 'types/network';
import useQueryHookWrapper from '../../../../../hooks/use-query-hook-wrapper';
import { servicesUsers } from '../../../../../services';
import { QueryConfig } from 'react-query/types/core/types';
import { TGetUserActivityLogsResponse } from 'types/entities/user-activity-logs';

const useUserActivityLogsGet = (
    query: string = '',
    arg0?: QueryConfig<TQueryDefWrapper<TGetUserActivityLogsResponse>, string>,
) => {
    return useQueryHookWrapper<
        TQueryDefWrapper<TGetUserActivityLogsResponse>,
        string,
        { query: string }
    >({
        queryKey: 'user-activity-logs',
        queryFn: servicesUsers.getUserActivityLogs,
        queryConfig: arg0,
        values: { query: query },
    });
};

export default useUserActivityLogsGet;
